import { PressResponder } from '@react-aria/interactions';
import type { OverlayTriggerState } from '@react-stately/overlays';
import type { ReactElement } from 'react';
import React, { Fragment } from 'react';
import type { DialogProps } from '../../../../../interface-and-type';
import { DialogContext } from '../dialog-context';

interface DialogTriggerBase {
  type: 'modal' | 'popover' | 'tray' | 'fullscreen' | 'fullscreenTakeover';
  state: OverlayTriggerState;
  isDismissable?: boolean;
  dialogProps?: DialogProps | {};
  triggerProps?: any;
  overlay: ReactElement;
  trigger: ReactElement;
}

export const DialogTriggerBase = ({
  type,
  state,
  isDismissable,
  dialogProps = {},
  triggerProps = {},
  overlay,
  trigger
}: DialogTriggerBase) => {
  let context = {
    type,
    onClose: state.close,
    isDismissable,
    ...dialogProps
  };

  return (
    <Fragment>
      <PressResponder
        {...triggerProps}
        onPress={state.toggle}
        isPressed={
          state.isOpen && type !== 'modal' && type !== 'fullscreen' && type !== 'fullscreenTakeover'
        }
      >
        {trigger}
      </PressResponder>
      <DialogContext.Provider value={context}>{overlay}</DialogContext.Provider>
    </Fragment>
  );
};
